// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3KnX1","checkboxCol":"Table_checkboxCol__14LIx","emailCol":"Table_emailCol__2WLl5","actionCol":"Table_actionCol__1t41s"};